import { NavLink } from 'react-router-dom';

const tabs = [
  { to: '/', label: 'Drive' },
  { to: '/earnings', label: 'Earnings' },
  { to: '/account', label: 'Account' },
];

export function TabBar() {
  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-[1001] flex justify-center pb-[max(env(safe-area-inset-bottom),0px)]"
    >
      <ul className="grid w-full max-w-mobile grid-cols-3 border-t border-line bg-surface">
        {tabs.map((t) => (
          <li key={t.to}>
            <NavLink
              to={t.to}
              end={t.to === '/'}
              className={({ isActive }) =>
                'flex h-14 items-center justify-center text-sm font-semibold ' +
                (isActive ? 'text-text' : 'text-muted hover:text-text')
              }
            >
              {t.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
